const initProductIncomingStock = () => {
  if (!window.themeCore || !window.themeCore.translations) {
    return;
  }

  const selectors = {
    section: '[data-section-type="product"]',
    incomingStock: ".js-product-incoming-stock",
    incomingStockText: ".js-product-incoming-stock-text",
    incomingStockVariants: "[data-incoming-stock-variants]"
  };
  const cssClasses = {
    hidden: "is-hidden"
  };
  const translations = {
    incomingStock: window.themeCore.translations.get("products.product.incoming_stock"),
    incomingStockWithDate: window.themeCore.translations.get("products.product.incoming_stock_with_date")
  };

  const sections = [...document.querySelectorAll(selectors.section)];

  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    const incomingStock = section.querySelector(selectors.incomingStock);

    if (!sectionId || !incomingStock) {
      return;
    }

    const incomingStockText = incomingStock.querySelector(selectors.incomingStockText);
    const variantsJSON = section.querySelector(selectors.incomingStockVariants);
    let variantsData = [];

    if (!incomingStockText) {
      return;
    }

    if (variantsJSON) {
      try {
        variantsData = JSON.parse(variantsJSON.textContent);
      } catch {
        variantsData = [];
      }
    }

    const getVariantData = (variant) => {
      if (!variant) {
        return null;
      }

      return variantsData.find((item) => Number(item.id) === Number(variant.id)) || variant;
    };

    const shouldShowIncoming = (variant) => {
      const variantData = getVariantData(variant);

      if (!variantData) {
        return false;
      }

      return Boolean(variantData.incoming);
    };

    const formatIncomingDate = (dateString) => {
      if (!dateString) {
        return "";
      }

      const date = new Date(dateString);

      if (Number.isNaN(date.getTime())) {
        return "";
      }

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    };

    const getIncomingStockText = (variant) => {
      const variantData = getVariantData(variant);
      const formattedDate = formatIncomingDate(variantData && variantData.next_incoming_date);

      if (formattedDate) {
        return translations.incomingStockWithDate.replace("{{ date }}", formattedDate);
      }

      return translations.incomingStock;
    };

    const updateIncomingStock = (variant) => {
      if (!shouldShowIncoming(variant)) {
        incomingStock.classList.add(cssClasses.hidden);
        incomingStockText.textContent = "";
        return;
      }

      incomingStockText.textContent = getIncomingStockText(variant);
      incomingStock.classList.remove(cssClasses.hidden);
    };

    window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, ({ variant }) => {
      updateIncomingStock(variant);
    });
  });
};

if (window.themeCore && window.themeCore.loaded) {
  initProductIncomingStock();
} else {
  document.addEventListener("theme:all:loaded", initProductIncomingStock, { once: true });
}
